module.exports = __webpack_public_path__ + "img/perimeter_security.117e4e59.png";